import React from "react";

function ProfileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      fill="none"
      viewBox="0 0 44 44"
    >
      <g
        stroke="#13121A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.75"
        clipPath="url(#clip0_226_708)"
      >
        <path d="M5.5 22a16.5 16.5 0 1033 0 16.5 16.5 0 00-33 0z"></path>
        <path d="M16.5 18.333a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zM11.308 34.556a7.334 7.334 0 017.025-5.223h7.333a7.334 7.334 0 017.03 5.235"></path>
      </g>
      <defs>
        <clipPath id="clip0_226_708">
          <path fill="#fff" d="M0 0H44V44H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProfileIcon;
